import { Ref, ref } from 'vue';
import emitter, { EB_EVENT_NAME } from '@/utils/eventbus';
import { ICommentData } from '@/service/broadcast/types';


export interface WarningContext {
  warning: Ref<ICommentData | null>,
  isVisible: Ref<boolean>,
}

const warning: Ref<ICommentData | null> = ref(null);
const isVisible: Ref<boolean> = ref(false);
const duration: number = 300 * 1000; // 5min


let clearTimer: NodeJS.Timeout | null = null;

const clearData = () => {
  warning.value = null;
  isVisible.value = false;
  emitter.off(EB_EVENT_NAME.ROOM_WARNING_SHOW);
  emitter.off(EB_EVENT_NAME.ROOM_WARNING_HIDE);

};

emitter.on(EB_EVENT_NAME.ROOM_WARNING_SET, (data: ICommentData) => {
  warning.value = data;
  if (clearTimer) {
    clearTimeout(clearTimer);
  }
  clearTimer = setTimeout(() => {
    clearData();
    clearTimer = null;
  }, duration);

  emitter.on(EB_EVENT_NAME.ROOM_WARNING_SHOW, () => isVisible.value = true);
  emitter.on(EB_EVENT_NAME.ROOM_WARNING_HIDE, () => isVisible.value = false);
});




// 警告弹窗高于弹幕警告
emitter.on(EB_EVENT_NAME.OPEN_WARNING_MODAL, () => clearData());
emitter.on(EB_EVENT_NAME.LIVE_BLOCK, () => clearData());

export default function useWarning(): WarningContext {
  return {
    warning,
    isVisible
  };
};
